import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { StateService } from '../../../services/state/state.service';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-cookies-dialog',
  templateUrl: './cookies-dialog.component.html',
  styleUrls: ['./cookies-dialog.component.scss'],
})
export class CookiesDialogComponent {
  public readonly FORM_NAME = {
    ESSENTIAL: 'essential',
    ANALYSIS_AND_STATISTICS: 'analysisAndStatistics',
  };

  public isLoading: boolean;
  public isOpenSetting: boolean;
  public submitForm: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<CookiesDialogComponent>,
    private stateService: StateService,
    private logger: NGXLogger
  ) {
    this.submitForm = new FormGroup({
      [this.FORM_NAME.ESSENTIAL]: new FormControl(
        { value: true, disabled: true },
        [Validators.requiredTrue]
      ),
      [this.FORM_NAME.ANALYSIS_AND_STATISTICS]: new FormControl(true),
    });
  }

  public isAbleToSubmit() {
    return !this.isLoading && this.submitForm.valid;
  }

  public submit() {
    if (!this.isAbleToSubmit()) {
      return;
    }

    try {
      this.isLoading = true;

      this.stateService.setCookiesConfig({
        essential: true,
        analysisAndStatistics: this.controlAnalysisAndStatisticsCookies.value,
      });

      this.closeDialog();
    } catch (e) {
      this.logger.error(e);
    } finally {
      this.isLoading = false;
    }
  }

  public acceptAllAndSubmit() {
    if (!this.isAbleToSubmit()) {
      return;
    }

    try {
      this.isLoading = true;

      this.stateService.setCookiesConfig({
        essential: true,
        analysisAndStatistics: true,
      });

      this.closeDialog();
    } catch (e) {
      this.logger.error(e);
    } finally {
      this.isLoading = false;
    }
  }

  public get controlAnalysisAndStatisticsCookies(): AbstractControl {
    return this.submitForm.get(this.FORM_NAME.ANALYSIS_AND_STATISTICS);
  }

  private closeDialog(): void {
    this.dialogRef.close(true);
  }
}
